import {
	showLoginRequestNotification,
	useNotifications,
} from "../notifications";
import * as borogove from "borogove";
import { Paper } from "@mui/material";
import Draggable from "react-draggable";
import { useState, useEffect } from "react";
import { Button } from "@chatscope/chat-ui-kit-react";
import { faGripHorizontal } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const LoginRequest = ({
	accounts,
}: {
	accounts: Record<string, { client: borogove.Client }>;
}) => {
	const { showNotification } = useNotifications();
	const [loginRequest, setLoginRequest] =
		useState<borogove.LoginRequest | null>(null);
	const [reqAccountId, setReqAccountId] = useState<string | null>(null);

	useEffect(() => {
		const tokens = Object.fromEntries(
			Object.keys(accounts).map((accountId) => {
				const client = accounts[accountId].client;
				return [
					accountId,
					client.addLoginRequestListener((req) => {
						setLoginRequest(req);
						setReqAccountId(accountId);
						showLoginRequestNotification(req, showNotification);
					}),
				];
			}),
		);

		return () => {
			for (const [accountId, t] of Object.entries(tokens)) {
				accounts[accountId].client.removeEventListener(t);
			}
		};
	}, [accounts, setLoginRequest, setReqAccountId, showNotification]);

	return (
		<>
			{loginRequest && reqAccountId && (
				<Draggable allowMobileScroll={true}>
					<div className="call-overlay">
						<Paper
							elevation={4}
							sx={{
								transform: "translateX(-50%)",
								padding: "1em 4em",
								borderRadius: "1em",
								textAlign: "center",
							}}
						>
							<FontAwesomeIcon
								icon={faGripHorizontal}
								style={{ marginBottom: "1em" }}
							/>

							<h2>Login Request</h2>
							<p>
								{loginRequest.method} {loginRequest.url}
							</p>
							<strong>{loginRequest.id}</strong>

							<div style={{ marginTop: "1.5em" }}>
								<Button
									border
									onClick={() => {
										accounts[reqAccountId].client.approveLoginRequest(
											loginRequest,
										);
										setLoginRequest(null);
									}}
									style={{
										borderRadius: "10em",
										padding: "0.5em 2em",
									}}
								>
									Approve Login
								</Button>
								<Button
									onClick={() => {
										accounts[reqAccountId].client.rejectLoginRequest(
											loginRequest,
											"User cancelled",
										);
										setLoginRequest(null);
									}}
									style={{
										background: "red",
										borderRadius: "10em",
										color: "white",
										padding: "0.5em 2em",
									}}
								>
									Cancel Login
								</Button>
							</div>
						</Paper>
					</div>
				</Draggable>
			)}
		</>
	);
};
